/* ================================================================
   LIFULL — dt-landing, JS extraido de sections/dt-landing.liquid
   (plan de rendimiento movil, Fase 2)
   Tres IIFE independientes (carrusel de resenas, observer de tarjetas
   de confianza, barra sticky + dtTriggerBuy/dtScrollTo), movidas tal
   cual sin cambiar su logica -- solo los 3 valores que antes venian
   interpolados por Liquid (section.id, product.handle, template.suffix)
   ahora se leen de window.__dtLandingConfig, que dt-landing.liquid
   sigue fijando con un <script> inline minimo antes de cargar este
   archivo. dtTriggerBuy() (usado por Releasit, boton "comprar ahora")
   no tenia ninguna interpolacion -- se movio sin ningun cambio. */


(function () {
  'use strict';
  var SID   = (window.__dtLandingConfig && window.__dtLandingConfig.sectionId) || '';
  var track = document.getElementById('dtc-tr-' + SID);
  var vp    = document.getElementById('dtc-vp-' + SID);
  if (!track) return;

  var reviewKey = (window.__dtLandingConfig && window.__dtLandingConfig.reviewKey) || '';

  var DREAM_TAPE_REVIEWS = [
    { i:'CR', g:'linear-gradient(135deg,#7C3AED,#EC4899)',   n:'Camila Rodríguez',  c:'Bogotá, Colombia',      t:'Lo recibí y esa misma noche lo usé. Al día siguiente me desperté sin ese cansancio de meses. Llevo 3 semanas y no lo dejo de usar. 100% recomendado.', d:'hace 2 días' },
    { i:'SM', g:'linear-gradient(135deg,#0891B2,#7C3AED)',   n:'Sebastián Morales', c:'Medellín, Colombia',     t:'Mi esposa llevaba meses quejándose de mis ronquidos. En una semana me dijo que ya no roncaba. La entrega rápida y el pago contraentrega son lo máximo.', d:'hace 4 días' },
    { i:'VG', g:'linear-gradient(135deg,#EC4899,#F97316)',   n:'Valentina Giraldo', c:'Cali, Colombia',         t:'Estaba escéptica pero lo probé y quedé sorprendida. Me levantó con la cara menos hinchada y con mucha más energía. Ya le compré a mi mamá también.', d:'hace 1 semana' },
    { i:'AP', g:'linear-gradient(135deg,#059669,#0891B2)',   n:'Andrés Pedraza',    c:'Barranquilla, Colombia', t:'Excelente calidad y entrega súper rápida, llegó en 3 días hábiles. Lo recomiendo totalmente, un producto increíble que realmente funciona.', d:'hace 1 semana' },
    { i:'MA', g:'linear-gradient(135deg,#7C3AED,#0891B2)',   n:'María Alejandra',   c:'Bucaramanga, Colombia',  t:'Llevaba años con garganta seca al despertar. Tres semanas después de empezar a usarlo ese problema desapareció completamente. ¡No lo cambio por nada!', d:'hace 2 semanas' },
    { i:'DF', g:'linear-gradient(135deg,#D97706,#EC4899)',   n:'Daniel Fuentes',    c:'Cartagena, Colombia',    t:'Llegó bien empacado y en perfectas condiciones. La calidad es increíble. Ya llevo un mes usándolo y no volvería a dormir sin él. ¡Gracias por tanto!', d:'hace 2 semanas' },
    { i:'LS', g:'linear-gradient(135deg,#A855F7,#EC4899)',   n:'Laura Salcedo',     c:'Pereira, Colombia',      t:'No creí que algo tan simple pudiera hacer tanto. Duermo mejor, me veo mejor y tengo más energía todo el día. Ya lo compré 3 veces y siempre llega perfecto.', d:'hace 3 semanas' },
    { i:'JC', g:'linear-gradient(135deg,#0891B2,#059669)',   n:'Juliana Castro',    c:'Manizales, Colombia',    t:'El pago contraentrega me dio confianza total para comprarlo. Llegó en perfectas condiciones y el producto realmente funciona como promete. ¡Lo amo!', d:'hace 3 semanas' },
    { i:'FO', g:'linear-gradient(135deg,#7C3AED,#D97706)',   n:'Felipe Ospina',     c:'Ibagué, Colombia',       t:'Mi familia y yo lo hemos probado y todos quedamos impresionados. La diferencia se siente desde la primera noche. Un producto que vale mucho la pena.', d:'hace 4 semanas' },
    { i:'IR', g:'linear-gradient(135deg,#EC4899,#7C3AED)',   n:'Isabella Ramírez',  c:'Santa Marta, Colombia',  t:'Increíble relación precio-calidad. El envío llegó rapidísimo y bien protegido. Ya se lo recomendé a todas mis amigas y varias ya lo compraron también.', d:'hace 1 mes' }
  ];

  var COLLAGEN_REVIEWS = [
    { i:'SR', g:'linear-gradient(135deg,#C084FC,#F472B6)',   n:'Sofía Ramírez',     c:'Medellín, Colombia',      t:'Compré el Multi Collagen porque quería ser más constante con mi rutina. Llevo 6 semanas y siento mi piel más firme y las uñas menos quebradizas.', d:'hace 2 días' },
    { i:'AM', g:'linear-gradient(135deg,#9333EA,#F472B6)',   n:'Andrea Morales',    c:'Bogotá, Colombia',        t:'Me gustó que sean 240 cápsulas porque no se acaba rápido. Lo tomo todos los días y mi cabello se ve con más brillo. El envío llegó súper bien.', d:'hace 4 días' },
    { i:'LP', g:'linear-gradient(135deg,#F472B6,#FB7185)',   n:'Laura Pineda',      c:'Cali, Colombia',          t:'Había probado colágeno en polvo y nunca fui juiciosa. Con estas cápsulas fue más fácil incluirlo en mi día a día. Ya pedí el segundo frasco.', d:'hace 1 semana' },
    { i:'MC', g:'linear-gradient(135deg,#7C3AED,#C084FC)',   n:'Mónica Cárdenas',   c:'Barranquilla, Colombia',  t:'La presentación se siente premium y la fórmula me convenció. Después de varias semanas noté mi piel menos opaca y las uñas más fuertes.', d:'hace 1 semana' },
    { i:'JR', g:'linear-gradient(135deg,#0891B2,#C084FC)',   n:'Juan Restrepo',     c:'Pereira, Colombia',       t:'Lo compré para apoyar articulaciones y recuperación después de entrenar. Me gustó mucho que no tenga sabor raro y que sea fácil de tomar.', d:'hace 2 semanas' },
    { i:'VG', g:'linear-gradient(135deg,#F472B6,#C084FC)',   n:'Valentina Gómez',   c:'Bucaramanga, Colombia',   t:'El frasco rinde bastante y eso da confianza. Mi rutina de piel se siente más completa desde que lo tomo con el desayuno todos los días.', d:'hace 2 semanas' },
    { i:'CP', g:'linear-gradient(135deg,#A855F7,#F472B6)',   n:'Carolina Pérez',    c:'Cartagena, Colombia',     t:'Llegó rápido y muy bien empacado. Me encanta que combine varios tipos de colágeno en una sola fórmula. Se volvió parte de mi rutina.', d:'hace 3 semanas' },
    { i:'NR', g:'linear-gradient(135deg,#C084FC,#0891B2)',   n:'Natalia Rojas',     c:'Manizales, Colombia',     t:'Lo empecé por recomendación y me sorprendió la constancia que logré. Mis uñas ya no se parten tanto y el cabello se siente más manejable.', d:'hace 3 semanas' },
    { i:'TO', g:'linear-gradient(135deg,#7C3AED,#F97316)',   n:'Tatiana Ospina',    c:'Ibagué, Colombia',        t:'La compra contraentrega me dio tranquilidad. El producto llegó perfecto y la cantidad de cápsulas hace que valga mucho la pena.', d:'hace 4 semanas' },
    { i:'DV', g:'linear-gradient(135deg,#F472B6,#7C3AED)',   n:'Daniela Vargas',    c:'Santa Marta, Colombia',   t:'Buscaba algo práctico para cuidado de piel, cabello y uñas. Este colágeno se siente completo y fácil de mantener en la rutina.', d:'hace 1 mes' }
  ];

  var GENERIC_REVIEWS = [
    { i:'MR', g:'linear-gradient(135deg,#C084FC,#F472B6)',   n:'María Restrepo',    c:'Bogotá, Colombia',        t:'La compra fue muy fácil y el producto llegó en pocos días. Me gustó la atención por WhatsApp y la opción de pago contraentrega.', d:'hace 3 días' },
    { i:'JG', g:'linear-gradient(135deg,#0891B2,#C084FC)',   n:'Julián Gómez',      c:'Medellín, Colombia',      t:'Todo llegó bien empacado y tal como se veía en la página. Se nota que cuidan los detalles y eso da confianza al comprar.', d:'hace 1 semana' },
    { i:'LC', g:'linear-gradient(135deg,#F472B6,#7C3AED)',   n:'Laura Castillo',    c:'Cali, Colombia',          t:'Me resolvieron las dudas antes de hacer el pedido y el envío fue rápido. Muy buena experiencia de compra con Lifull.', d:'hace 2 semanas' }
  ];

  var REVIEWS = /collagen|collageno|colageno/.test(reviewKey)
    ? COLLAGEN_REVIEWS
    : (/dream|tape/.test(reviewKey) ? DREAM_TAPE_REVIEWS : GENERIC_REVIEWS);

  /* ── Collect photo cards from Liquid, build text cards ── */
  var photoHTMLs = Array.from(track.querySelectorAll('.dtc-card--photo')).map(function(n){ return n.outerHTML; });

  /* Bloques "resena_texto" del editor -- si hay alguno configurado para
     este producto, tienen prioridad sobre los arrays hardcodeados de
     abajo (que quedan intactos como fallback para productos sin
     bloques, ej. colageno/dream-tape). Ya vienen armados desde Liquid,
     mismo patron que photoHTMLs -- no se duplica el armado del HTML. */
  var manualTextHTMLs = Array.from(track.querySelectorAll('.dtc-card--text-manual')).map(function(n){ return n.outerHTML; });

  var textCards;
  if (manualTextHTMLs.length > 0) {
    textCards = manualTextHTMLs;
  } else {
    textCards = REVIEWS.map(function (r) {
      return '<article class="dtc-card">' +
        '<div class="dtc-c-head">' +
          '<div class="dtc-av" style="background:' + r.g + '">' + r.i + '</div>' +
          '<div><div class="dtc-uname">' + r.n + '</div><div class="dtc-uloc">' + r.c + '</div></div>' +
        '</div>' +
        '<div class="dtc-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>' +
        '<p class="dtc-quote">' + r.t + '</p>' +
        '<div class="dtc-c-foot">' +
          '<span class="dtc-badge">&#10003; Compra verificada</span>' +
          '<span class="dtc-date">' + r.d + '</span>' +
        '</div>' +
      '</article>';
    });
  }

  /* ── Intersperse: 1 photo after every 2 text cards ──
     El recorrido tiene que tener huecos suficientes para todas las
     fotos reales (photoHTMLs.length * 2), no solo los que entran en
     textCards.length -- si hacen falta mas huecos que reseñas de
     texto, se ciclan las tarjetas de texto (ya son genericas) en vez
     de cortar el recorrido y perder fotos subidas por el editor. */
  var mixed = [];
  var pi = 0;
  var loopLength = textCards.length;
  if (photoHTMLs.length > 0 && photoHTMLs.length * 2 > loopLength) {
    loopLength = photoHTMLs.length * 2;
  }
  for (var i = 0; i < loopLength; i++) {
    mixed.push(textCards[i % textCards.length]);
    if (photoHTMLs.length > 0 && (i + 1) % 2 === 0) {
      mixed.push(photoHTMLs[pi % photoHTMLs.length]);
      pi++;
    }
  }

  var allHTML = mixed.join('');
  track.innerHTML = allHTML + allHTML; /* duplicate for seamless loop */

  /* ── Animation ── */
  var GAP = 16;
  var totalW = 0;
  var cardStep = 310 + GAP; /* ancho de un paso de flecha -- precalculado aca, nunca leido dentro de un click */
  function applyAnim() {
    var cards = track.querySelectorAll('.dtc-card');
    var half  = Math.floor(cards.length / 2);
    totalW = 0;
    for (var j = 0; j < half; j++) totalW += (cards[j] ? cards[j].offsetWidth : 310) + GAP;
    if (cards[0]) cardStep = cards[0].offsetWidth + GAP;
    var dur = Math.round(totalW / 52);
    track.style.setProperty('--dtc-dist', '-' + totalW + 'px');
    track.style.setProperty('--dtc-dur',  dur + 's');
  }
  requestAnimationFrame(applyAnim);

  /* ── Drag + flechas + smart pause (mismo mecanismo para las tres) ── */
  var drag = false, sx = 0, lastX = 0, frozenX = 0, resumeTimer;

  function getComputedX() {
    var m = window.getComputedStyle(track).transform;
    if (!m || m === 'none') return 0;
    var v2 = m.match(/^matrix\(([^)]+)\)$/);
    if (v2) return parseFloat(v2[1].split(',')[4]) || 0;
    var v3 = m.match(/^matrix3d\(([^)]+)\)$/);
    if (v3) return parseFloat(v3[1].split(',')[12]) || 0;
    return 0;
  }

  /* Congela el track en rawOffsetX (normalizado al ancho total) y
     reanuda la animacion de CSS sola a los 4s -- usado tanto al soltar
     el arrastre como al hacer click en una flecha. withTransition
     agrega un deslizamiento suave (las flechas lo usan, el arrastre no,
     porque el arrastre ya sigue el dedo/mouse 1:1 frame a frame). */
  function settle(rawOffsetX, withTransition) {
    var dist = totalW || 3600;
    var dur  = parseFloat(track.style.getPropertyValue('--dtc-dur') || 55);
    var modX = (((-rawOffsetX) % dist) + dist) % dist;
    var pauseOffset = -modX;
    /* Un animation-play-state "paused" NO le saca prioridad a la
       animacion de CSS sobre un transform inline en el valor
       RENDERIZADO -- solo congela su progreso, pero sigue "ganando" en
       la cascada sobre el transform que se fija abajo (esto es lo que
       hacia que el paso de una flecha terminara en una posicion
       corrida: el navegador seguia mostrando el frame de la animacion,
       no mi transform). Por eso se saca la animacion por completo
       (animationName = 'none') mientras esta congelado, en vez de solo
       pausarla -- asi el transform inline manda de verdad. */
    track.style.animationName = 'none';
    track.style.transition = withTransition ? 'transform .4s cubic-bezier(.22,1,.36,1)' : '';
    track.style.transform = 'translateX(' + pauseOffset + 'px)';
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () {
      /* sync animation-delay then hand off to CSS anim in same frame */
      track.style.transition = '';
      track.style.animationDelay = -(modX / dist * dur) + 's';
      track.style.transform = '';
      track.style.animationName = '';
    }, 4000);
  }

  vp.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    e.preventDefault();
    clearTimeout(resumeTimer);
    track.style.transition = ''; /* cancela cualquier deslizamiento pendiente de una flecha antes de arrastrar */
    drag = true; sx = e.clientX; lastX = e.clientX;
    frozenX = getComputedX();
    track.style.animationName = 'none';
    track.style.transform = 'translateX(' + frozenX + 'px)';
    vp.classList.add('is-dragging');
    vp.setPointerCapture(e.pointerId);
  }, { passive: false });

  vp.addEventListener('pointermove', function (e) {
    if (!drag) return;
    e.preventDefault();
    lastX = e.clientX;
    track.style.transform = 'translateX(' + (frozenX + (e.clientX - sx)) + 'px)';
  }, { passive: false });

  function endDrag() {
    if (!drag) return;
    drag = false;
    vp.classList.remove('is-dragging');
    settle(frozenX + (lastX - sx), false);
  }

  vp.addEventListener('pointerup',     endDrag);
  vp.addEventListener('pointercancel', endDrag);

  /* ── Flechas de navegacion manual ──
     Un paso = el ancho de una tarjeta (cardStep, precalculado en
     applyAnim, nunca leido aca). Misma pausa/reanudacion que el
     arrastre via settle() -- no es un sistema paralelo.

     Si la animacion automatica seguia corriendo, getComputedX() agarra
     la posicion continua en la que iba en ese instante -- un punto
     cualquiera entre dos tarjetas, no el borde de una. Sin ajustar eso,
     el primer click de una flecha "saltaba" desde ahi, y se sentia como
     que iba a una reseña al azar en vez de avanzar una por una. Por eso
     primero se redondea al borde de tarjeta mas cercano (snap) y recien
     ahi se da el paso -- asi siempre avanza/retrocede exactamente una
     tarjeta, sin importar si es foto o texto. */
  function stepCarousel(dir) {
    clearTimeout(resumeTimer);
    var currentX = getComputedX();
    var snapped = Math.round(currentX / cardStep) * cardStep;
    settle(snapped - (dir * cardStep), true);
  }

  var prevBtn = document.getElementById('dtc-prev-' + SID);
  var nextBtn = document.getElementById('dtc-next-' + SID);
  if (prevBtn) prevBtn.addEventListener('click', function () { stepCarousel(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { stepCarousel(1); });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyAnim, 150);
  });
})();

(function(){
  var grid = document.getElementById('dt-trust-grid-' + ((window.__dtLandingConfig && window.__dtLandingConfig.sectionId) || ''));
  if (!grid) return;
  var cards = grid.querySelectorAll('.dt-trust__card');
  if (!cards.length) return;

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('dt-in');
        obs.unobserve(e.target);
        /* clear stagger delay after animation so hover has instant response */
        var delay = parseFloat(getComputedStyle(e.target).getPropertyValue('--dt-card-delay')) || 0;
        setTimeout(function() {
          e.target.style.removeProperty('--dt-card-delay');
        }, (delay + 0.6) * 1000);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    cards.forEach(function(c) { obs.observe(c); });
  } else {
    cards.forEach(function(c) { c.classList.add('dt-in'); });
  }
})();

(function () {
  'use strict';

  /* ── Add body class for padding ── */
  document.body.classList.add('dt-active');

  /* ── Smooth scroll to a section ── */
  window.dtScrollTo = function (id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ── Find the buy button — RSI buy-now first, then standard ATC ── */
  function findAtcButton() {
    return (
      document.querySelector('#_rsi-buy-now-button') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('button[data-type="add-to-cart"]')
    );
  }

  /* ── Find the product form section for fallback scroll ── */
  function findProductSection() {
    return (
      document.querySelector('.shopify-section--main-product') ||
      document.querySelector('[data-section-id]') ||
      document.querySelector('.main-product') ||
      document.querySelector('product-form') ||
      document.querySelector('.product-form')
    );
  }

  /* ── Main buy action ── */
  window.dtTriggerBuy = function (trigger) {
    /* RSI COD button — click directly, it handles its own modal opening */
    var rsiBtn = document.querySelector('#_rsi-buy-now-button');
    if (rsiBtn) {
      rsiBtn.click();
      return;
    }

    /* Fallback: standard Shopify ATC button */
    var originalHTML = trigger ? trigger.innerHTML : '';
    var atc = findAtcButton();

    if (atc) {
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (trigger) trigger.textContent = '⏳  Agregando...';
      setTimeout(function () {
        atc.click();
        if (trigger) {
          setTimeout(function () { trigger.innerHTML = originalHTML; }, 2200);
        }
      }, 500);
    } else {
      var section = findProductSection();
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  /* ── Sticky bar: always visible, slide in after first paint ── */
  var stickyBar = document.getElementById('dt-sticky-bar');
  if (stickyBar) {
    setTimeout(function () { stickyBar.classList.add('dt-show'); }, 350);
  }

  /* ── Scroll reveal ── */
  var revEls = document.querySelectorAll('#dt-lp .dt-reveal');

  if ('IntersectionObserver' in window) {
    var revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('dt-in');
          revObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revEls.forEach(function (el) { revObs.observe(el); });
  } else {
    /* Fallback for old browsers */
    revEls.forEach(function (el) { el.classList.add('dt-in'); });
  }

})();
